
import React, { useEffect, useState } from "react";
import baseURL from "../../Components/url";
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'

export default function DeveloperAdmin() {
  const [modalOpen, setModalOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [form, setForm] = useState({ nombre: "", url: "", copyright: "" });

  const toggleModal = () => {
    setMensaje("");
    setModalOpen(!modalOpen);
  };

  const cargar = () => {
    fetch(`${baseURL}/developerGet.php`)
      .then((r) => r.json())
      .then((data) => {
        const dev = Array.isArray(data) ? data[0] : data;
        setForm({
          nombre: dev?.nombre ?? "",
          url: dev?.url ?? "",
          copyright: dev?.copyright ?? "",
        });
      })
      .catch(console.error);
  };

  useEffect(() => {
    cargar();
  }, []);

  const onChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const guardar = async () => {
    setMensaje("Procesando...");

    try {
      const fd = new FormData();
      fd.append("nombre", form.nombre);
      fd.append("url", form.url);
      fd.append("copyright", form.copyright);

      const res = await fetch(`${baseURL}/developerUpdate.php`, {
        method: "POST",
        body: fd,
      });

      const data = await res.json();

      if (!res.ok || data?.ok === false) {
        throw new Error(data?.error || "No se pudo guardar");
      }

      setMensaje("");
      // reflejar cambios: recarga para que el componente Developer vuelva a pedir el GET
      window.location.reload();
    } catch (err) {
      console.error(err);
      setMensaje(err.message);
    }
  };

  return (
    <div className="NewPedido">
      <button onClick={toggleModal} className="btnSave">
        <span>✎</span> Developer
      </button>

      {modalOpen && (
        <div className="modal">
          <div className="modal-content">
            <div className="deFlexBtnsModal">
              <button className="selected">Editar Developer</button>
              <span className="close" onClick={toggleModal}>&times;</span>
            </div>

            <legend>(*) Campos obligatorios</legend>

            <div className="flexGrap">
              <fieldset>
                <legend>Nombre (*)</legend>
                <input
                  type="text"
                  name="nombre"
                  value={form.nombre}
                  onChange={onChange}
                />
              </fieldset>

              <fieldset>
                <legend>URL (*)</legend>
                <input
                  type="text"
                  name="url"
                  value={form.url}
                  onChange={onChange}
                />
              </fieldset>

              <fieldset>
                <legend>Copyright (*)</legend>
                <input
                  type="text"
                  name="copyright"
                  value={form.copyright}
                  onChange={onChange}
                />
              </fieldset>
            </div>

            {mensaje ? (
              <button type="button" className="btnLoading" disabled>
                {mensaje}
              </button>
            ) : (
              <button type="button" onClick={guardar} className="btnPost">
                Guardar
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

